/**
 * The key that sits UNDER a chart, never beside it.
 *
 * Recharts' own <Legend layout="vertical" align="right"> looked fine on a
 * 1920 monitor and, on the CMD's phone (12-09-2026), printed fifteen category
 * names straight across the doughnut. A legend has no minimum width of its
 * own, so on a narrow card it simply overlaps the drawing.
 *
 * This one is ordinary HTML below the chart: one column on a phone, two from
 * the small breakpoint, three on a wide screen. It wraps, it truncates a long
 * name rather than pushing the figure off the card, and it can carry the value
 * beside each name - which the Recharts legend cannot do at all.
 */
export interface LegendItem {
  name: string
  color: string
  /** Optional figure shown on the right - a rupee amount, a count, a share. */
  value?: string
}

export function ChartLegend({ items, className = '' }: { items: LegendItem[]; className?: string }) {
  if (items.length === 0) return null
  return (
    <ul className={`mt-2 grid grid-cols-1 gap-x-5 gap-y-1 sm:grid-cols-2 xl:grid-cols-3 ${className}`}>
      {items.map((it) => (
        <li key={it.name} className="flex items-center justify-between gap-2 text-[11px] leading-5">
          <span className="flex min-w-0 items-center gap-1.5">
            <span className="h-2.5 w-2.5 shrink-0 rounded-sm" style={{ background: it.color }} aria-hidden />
            <span className="truncate text-slate-600" title={it.name}>{it.name}</span>
          </span>
          {it.value && <span className="shrink-0 tabular-nums font-semibold text-slate-700">{it.value}</span>}
        </li>
      ))}
    </ul>
  )
}
